// extracted by mini-css-extract-plugin
module.exports = {"root":"DisplayYear-module--root--3QF9z"};